module.exports = __webpack_public_path__ + "static/media/realisasi.a1c1c2dc.png";